import apiClient from './client';

export async function getSettledTransactions() {
  // size=10000 loads all items; paginate properly when needed
  const res = await apiClient.get('/api/v1/transactions/settled', { params: { page: 0, size: 10000 } });
  return res.data.items ?? res.data;
}

export async function getSettledStatus() {
  const res = await apiClient.get('/api/v1/transactions/settled/status');
  return res.data;
}

export async function getWashSales() {
  const res = await apiClient.get('/api/v1/transactions/wash-sales');
  return res.data;
}

export async function getTaxRealized(type) {
  const params = type ? { type } : {};
  const res = await apiClient.get('/api/v1/tax/realized', { params });
  return res.data;
}

export async function getHarvestOpportunities(type) {
  const res = await apiClient.get('/api/v1/tax/harvest/opportunities', { params: { type } });
  return res.data;
}

export async function simulateTaxImpact(body) {
  const res = await apiClient.post('/api/v1/tax/simulate', body);
  return res.data;
}

export async function executeTaxHarvest(trades) {
  const res = await apiClient.post('/api/v1/tax/harvest/execute', trades);
  return res.data;
}

export async function optimizeLiquidation(body) {
  const res = await apiClient.post('/api/v1/liquidation/optimize', body);
  return res.data;
}

export async function executeLiquidation(trades) {
  const res = await apiClient.post('/api/v1/liquidation/execute', trades);
  return res.data;
}